<div fxLayout="row" fxLayoutAlign="space-between center">
  <div
    fxFlex="55"
    fxFlex.sm="100"
    fxFlex.xs="100"
    fxLayout="column"
    fxLayoutAlign="space-between stretch"
  >
    <div fxFlex="100">
      <mat-form-field appearance="outline">
        <mat-label>Nombre completo</mat-label>
        <input matInput [formControl]="nameFormControl" />
        <mat-error *ngIf="emailFormControl.hasError('required')">
          El nombre completo es <strong>requerido</strong>
        </mat-error>
      </mat-form-field>
    </div>
    <!-- -- -->
    <div fxFlex="100">
      <!-- <mat-form-field appearance="outline">
          <mat-label>Correo electrónico *</mat-label>
          <input matInput />
        </mat-form-field> -->

      <form class="example-form">
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>Correo electrónico</mat-label>
          <input
            type="email"
            matInput
            [formControl]="emailFormControl"
            [errorStateMatcher]="matcher"
            placeholder="Ex. pat@example.com"
          />
          <!-- <mat-hint>Error de formato!</mat-hint> -->
          <mat-error
            *ngIf="
              emailFormControl.hasError('email') &&
              !emailFormControl.hasError('required')
            "
          >
            Por favor, introduce una dirección de correo electrónico válida
          </mat-error>
          <mat-error *ngIf="emailFormControl.hasError('required')">
            El correo electrónico es <strong>requerido</strong>
          </mat-error>
        </mat-form-field>
      </form>
    </div>
    <!-- -- -->
    <div fxFlex="100">
      <mat-form-field appearance="outline">
        <mat-label>Asunto</mat-label>
        <input matInput [formControl]="subjectFormControl" />
        <mat-error *ngIf="emailFormControl.hasError('required')">
          El asunto es <strong>requerido</strong>
        </mat-error>
      </mat-form-field>
    </div>
    <div fxFlex="100">
      <mat-form-field appearance="outline">
        <mat-label>Mensaje</mat-label>

        <textarea
          matInput
          rows="4"
          [formControl]="messageFormControl"
        ></textarea>
      </mat-form-field>
    </div>
    <div fxFlex="100">
      <button mat-flat-button color="primary" (click)="fnSendMessage()">
        <mat-icon>send</mat-icon> Enviar
      </button>
    </div>
  </div>

  <div fxFlex="45" fxFlex.sm="100" fxFlex.xs="100">
    <div style="padding: 2em; font-size: 1.2em; color: #e7154a">
      <p>¿Alguna pregunta?</p>
      <p>
        Escríbenos a papasnativas22@gmail.com o llenando el siguiente
        formulario.
      </p>
      <p>Así podremos ayudarte a resolver cualquier duda.</p>
    </div>
  </div>
</div>
